import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatSortModule} from '@angular/material/sort';
import {MatExpansionModule }  from '@angular/material/expansion'
import {MatGridListModule,MatGridList }  from '@angular/material/grid-list'
import {MatCardModule }  from '@angular/material/card'
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
//import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule, } from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatAutocompleteModule} from '@angular/material/autocomplete'





/*-------------------------*/
import { NavigationComponent } from './navigation/navigation.component';
import { RelatiesviewComponent } from './relaties/relatiesview/relatiesview.component';
import { AuthGuardService } from "./shared/auth/AuthGuardService";
import { AuthRegisterService } from "./shared/auth/AuthRegisterService";
import { AuthenticationService } from './shared/auth/authentication.service';
import { AuthLogoutService } from './shared/auth/AuthLogoutService';
import { TokenInterceptor } from './shared/auth/TokenInterceptor ';
import { AdminLocalStorageService } from './shared/auth/admin-local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule, registerLocaleData } from '@angular/common';

import { ToastrModule } from 'ngx-toastr';
import { GetTokenComponent } from './get-token/get-token.component';
import { ObjectentableComponent } from './objecten/objectentable/objectentable.component';
import { OffertetableComponent } from './offerte/offertetable/offertetable.component';
import { RelatiesService } from './shared/dataservices/relaties.service';
import { RelatieEditComponent } from './relaties/relatie-edit/relatie-edit.component';
import { TypeSelectorComponent } from './relaties/type-selector/type-selector.component';
import { FactuuradressenlistComponent } from './relaties/factuuradressen/factuuradressenlist/factuuradressenlist.component';
import { FactuuradresseneditComponent } from './relaties/factuuradressen/factuuradressenedit/factuuradressenedit.component';
import { CustomMaterialModule } from './general/custom-material/custom-material.module';
import { ConfirmDialogComponent } from "./general/confirm-dialog/confirm-dialog.component";
import { AfleveradresseneditComponent } from './relaties/afleveradressen/afleveradressenedit/afleveradressenedit.component';
import { AfleveradressenlistComponent } from './relaties/afleveradressen/afleveradressenlist/afleveradressenlist.component';
import { ContactpersonenlistComponent } from './relaties/contactpersonen/contactpersonenlist/contactpersonenlist.component';
import { ContactpersoneneditComponent } from './relaties/contactpersonen/contactpersonenedit/contactpersonenedit.component';
import { ContactpersonenviewComponent } from './relaties/contactpersonen/contactpersonenview/contactpersonenview.component';
import { ObjectSelectComponent } from './objecten/object-select/object-select.component';
import { ObjectComponent } from './objecten/object/object.component';
import { ObjectEditComponent } from './objecten/object-edit/object-edit.component';
import { ObjectNavComponent } from './objecten/object-nav/object-nav.component';
import { InputDialogComponent } from './general/input-dialog/input-dialog.component';
import { StatusListComponent } from './objecten/status/status-list/status-list.component';
import { StatusEditComponent } from './objecten/status/status-edit/status-edit.component';
import { RelatieAddComponent } from './relaties/relatie-add/relatie-add.component';
import { ObjectAddComponent } from './objecten/object-add/object-add.component';
import { StatusTableComponent } from './objecten/status-table/status-table.component';
import { AuthComponent } from './auth/auth.component';
import {ObjectAfleveradresListComponent} from './objecten/afleveradressen/afleveradres-list/afleveradres-list.component'
import {ObjectAfleveradresEditComponent} from './objecten/afleveradressen/afleveradres-edit/afleveradres-edit.component';
import { OfferteFilterComponent } from './offerte/offerte-filter/offerte-filter.component';
import { OfferteNavComponent } from './offerte/offerte-nav/offerte-nav.component';
import { OfferteEditComponent } from './offerte/edit/offerte-edit/offerte-edit.component';
import { OfferteEditLinesComponent } from './offerte/edit/offerte-edit-lines/offerte-edit-lines.component';
import { OfferteViewComponent } from './offerte/offerte-view/offerte-view.component';
import { OfferteEditLineComponent } from './offerte/edit/offerte-edit-line/offerte-edit-line.component'
import { FactuurFilterComponent } from './factuur/factuur-filter/factuur-filter.component';
import { FactuurNavComponent } from './factuur/factuur-nav/factuur-nav.component';
import { FactuurEditComponent } from './factuur/edit/factuur-edit/factuur-edit.component';
import { FactuurEditLinesComponent } from './factuur/edit/factuur-edit-lines/factuur-edit-lines.component';
import { FactuurEditLineComponent } from './factuur/edit/factuur-edit-line/factuur-edit-line.component'
import { FactuurViewComponent } from './factuur/factuur-view/factuur-view.component';
import { NewFactuurComponent } from './objecten/object-edit/new-factuur/new-factuur.component';
import { NewOfferteComponent } from './objecten/object-edit/new-offerte/new-offerte.component';
//Locale NL laden en installeren
import localeNL from '@angular/common/locales/nl';
import { SelectAdresComponent } from './relaties/select-adres/select-adres.component';
import { ObjectSelectListComponent } from './objecten/object-select-list/object-select-list.component';
import { InputrelatieComponent } from './shared/components/inputrelatie/inputrelatie.component';
import { ChangeNumberComponent } from './objecten/object-edit/change-number/change-number.component';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { HomeComponent } from './home/home.component';
import { CustomDateAdapter } from './shared/custom.date.adapter';
import { StatusOverzichtFilterComponent } from './objecten/status-overzicht/status-overzicht-filter/status-overzicht-filter.component';
import { StatusOverzichtViewComponent } from './objecten/status-overzicht/status-overzicht-view/status-overzicht-view.component';
import { StatusOverzichtObjectComponent } from './objecten/status-overzicht/status-overzicht-object/status-overzicht-object.component';
import { StatusOverzichtComponent } from './objecten/status-overzicht/leverancier/status-overzicht/status-overzicht.component';
import { StatusOverzichtSelectComponent } from './objecten/status-overzicht/leverancier/status-overzicht-select/status-overzicht-select.component';
registerLocaleData(localeNL);




@NgModule({
    declarations: [
        AppComponent,
        NavigationComponent,
        RelatiesviewComponent,
        GetTokenComponent,
        ObjectentableComponent,
        OffertetableComponent,
        RelatieEditComponent,
        TypeSelectorComponent,
        FactuuradressenlistComponent,
        FactuuradresseneditComponent,
        ConfirmDialogComponent,
        InputDialogComponent,
        AfleveradresseneditComponent,
        AfleveradressenlistComponent,
        ContactpersonenlistComponent,
        ContactpersoneneditComponent,
        ContactpersonenviewComponent,
        ObjectSelectComponent,
        ObjectComponent,
        ObjectEditComponent,
        ObjectNavComponent,
        StatusListComponent,
        StatusEditComponent,
        RelatieAddComponent,
        ObjectAddComponent,
        StatusTableComponent,
        AuthComponent,
        ObjectAfleveradresListComponent,
        ObjectAfleveradresEditComponent,
        OfferteFilterComponent,
        OfferteNavComponent,
        OfferteEditComponent,
        OfferteEditLinesComponent,
        OfferteViewComponent,
        OfferteEditLineComponent,
        FactuurViewComponent,
        FactuurFilterComponent,
        FactuurNavComponent,
        FactuurEditComponent,
        FactuurEditLinesComponent,
        FactuurEditLineComponent,
        NewFactuurComponent,
        NewOfferteComponent,
        SelectAdresComponent,
        ObjectSelectListComponent,
        InputrelatieComponent,
        ChangeNumberComponent,
        HomeComponent,
        StatusOverzichtFilterComponent,
        StatusOverzichtViewComponent,
        StatusOverzichtObjectComponent,
        StatusOverzichtComponent,
        StatusOverzichtSelectComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSidenavModule,
        MatToolbarModule,
        MatListModule,
        MatIconModule,
        ToastrModule.forRoot(),
        HttpClientModule,
        MatTableModule,
        FormsModule, ReactiveFormsModule,
        MatInputModule, MatSortModule,
        MatExpansionModule, MatGridListModule, MatCardModule,
        CustomMaterialModule, MatButtonModule, MatDialogModule,
        MatSelectModule, MatMenuModule, MatDatepickerModule, MatCheckboxModule,
        MatNativeDateModule, MatAutocompleteModule
        //,MultiColumnSelectModule
    ],
    providers: [AuthGuardService, AuthenticationService, AdminLocalStorageService, ToastrService, AuthRegisterService,
        AuthLogoutService, RelatiesService, MatGridList,
        //enures that the week begins on a monday
        { provide: DateAdapter, useClass: CustomDateAdapter },
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'auto',appearance: 'fill'}},
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
